import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import truncate from 'lodash-es/truncate';
import { PAGE_CUSTOMER } from '../../../App';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux/actions';
import { Separator, Box } from '../../../components/containers';
import { Headline } from '../../../components/text';
import { Button } from '../../../components/actions';
import { REPORT_REQUEST_STATUS } from '../constants';
import { selectReportCategoryDetails } from './selectors';
import { createReportRequest } from '../action';
import AnimateHeight from 'react-animate-height';
import zenscroll from 'zenscroll';
import RequestFormAutocompleteParam from './Autocomplete';
import triangleTop from '../../../img/triangle-top.svg';
import triangleBottom from '../../../img/triangle-bottom.svg';
import tickIcon from '../../../img/tick-green-icon.svg';
import s from './index.css';

const propTypes = {
    requestId: PropTypes.number.isRequired,
    requestName: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
    reportCategoryDetails: selectReportCategoryDetails(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch,
    createReportRequest: bindActionCreators(createReportRequest, dispatch),
});

class RequestReportForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            maxAccordionHeight: 0,
            requestParams: [],
            requestStatus: REPORT_REQUEST_STATUS.None,
        };
    }

    componentWillMount() {
        this.setInitialReportParamsState(this.props.reportCategoryDetails);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.reportCategoryDetails === null ||
            (this.props.reportCategoryDetails === null && nextProps.reportCategoryDetails) ||
            (this.props.reportCategoryDetails &&
                nextProps.reportCategoryDetails &&
                this.props.reportCategoryDetails.reportId !== nextProps.reportCategoryDetails.reportId)
        ) {
            this.setInitialReportParamsState(nextProps.reportCategoryDetails);
        }
    }

    render() {
        const { requestId, requestName, reportCategoryDetails } = this.props;

        return (
            <Fragment>
                <Headline size="medium" isDark={true}>
                    {requestName}
                </Headline>

                <Separator type="narrow" />

                <Box addShadow={true}>
                    {reportCategoryDetails &&
                        reportCategoryDetails.params.map((param, paramIndex) => {
                            const paramState =
                                this.state.requestParams[paramIndex] &&
                                this.state.requestParams[paramIndex].paramId === param.reportParamId
                                    ? this.state.requestParams[paramIndex]
                                    : null;

                            return paramState ? (
                                <div key={param.reportId + '-' + param.reportParamId} className={s.param}>
                                    <button
                                        className={classNames(s.paramHeader, {
                                            [s.expanded]: paramState.isExpanded,
                                            [s.valid]: paramState.value,
                                        })}
                                        onClick={this.handleToggleParamExpansion(paramIndex)}
                                    >
                                        <div className={s.paramNameAndValueContainer}>
                                            <h2 className={s.paramName}>{param.reportParamName}</h2>

                                            {(paramState.value || paramState.valueText) && (
                                                <h3
                                                    className={s.paramValue}
                                                    title={
                                                        paramState.valueText
                                                            ? paramState.valueText
                                                            : paramState.value
                                                                ? paramState.value
                                                                : undefined
                                                    }
                                                >
                                                    {truncate(
                                                        paramState.valueText
                                                            ? paramState.valueText
                                                            : paramState.value
                                                                ? paramState.value
                                                                : '',
                                                        {
                                                            length: 64,
                                                        }
                                                    )}
                                                </h3>
                                            )}
                                        </div>

                                        {param.reportParamRequired === 'yes' && (
                                            <p className={s.paramRequired}>Required</p>
                                        )}

                                        <div>
                                            <span className={s.paramExpandIcon}>
                                                <img
                                                    src={paramState.isExpanded ? triangleTop : triangleBottom}
                                                    alt=""
                                                />
                                            </span>
                                        </div>

                                        <img className={s.paramValueIsValid} src={tickIcon} alt="" />
                                    </button>

                                    <AnimateHeight height={paramState.isExpanded ? 'auto' : 0} duration={500}>
                                        <div className={classNames(s.paramBody)}>
                                            {(param.reportFieldType === 'autocomplete' && (
                                                <RequestFormAutocompleteParam
                                                    onChange={this.handleParamValueChange(paramIndex)}
                                                    maxAccordionHeight={this.state.maxAccordionHeight}
                                                    searchPlaceholder={
                                                        param.reportParamLabel
                                                            ? param.reportParamLabel
                                                            : param.reportParamName
                                                                ? param.reportParamName
                                                                : ''
                                                    }
                                                    values={param.values}
                                                    selected={paramState.value || null}
                                                    expanded={paramState.isExpanded}
                                                />
                                            )) || (
                                                <p className={s.paramNotDefined}>
                                                    {'This report parameter is not defined. ' +
                                                        'Please contact portal administrator and report the issue.'}
                                                </p>
                                            )}
                                        </div>
                                    </AnimateHeight>
                                </div>
                            ) : null;
                        })}
                </Box>

                <Separator type="standard" />

                <div className={s.summary}>
                    <p className={s.error}>
                        {this.state.requestStatus === REPORT_REQUEST_STATUS.ErrorAllRequiredFieldsAreNeeded
                            ? 'All required parameters need to be filled'
                            : this.state.requestStatus === REPORT_REQUEST_STATUS.Error
                                ? 'Could not create request, try again'
                                : ''}
                    </p>

                    <Button
                        onClick={this.handleRequestSubmit}
                        align="right"
                        label={
                            this.state.requestStatus === REPORT_REQUEST_STATUS.Saving
                                ? 'Submitting report request'
                                : 'Submit report request'
                        }
                        isLoading={this.state.requestStatus === REPORT_REQUEST_STATUS.Saving}
                        withBox={true}
                        design="blue"
                    />
                </div>
            </Fragment>
        );
    }

    handleToggleParamExpansion = paramIndex => e => {
        const expand = !this.state.requestParams[paramIndex].isExpanded;

        if (expand) {
            this.setState({
                maxAccordionHeight: window.innerHeight - 83 - 63 - 12 - 69 - 128,
            });
        }

        // Collapse all other params if user is expanding closed param
        // Collapse only clicked param if user is collapsing it individually
        this.setState({
            requestParams: this.state.requestParams.map((paramState, paramStateIndex) => ({
                ...paramState,
                isExpanded: expand
                    ? paramStateIndex === paramIndex
                        ? expand
                        : false
                    : paramStateIndex === paramIndex
                        ? expand
                        : paramState.isExpanded,
            })),
        });
    };

    handleParamValueChange = paramIndex => (value, valueText) => {
        this.setState({
            requestParams: [
                ...this.state.requestParams.slice(0, paramIndex),
                {
                    ...this.state.requestParams[paramIndex],
                    isExpanded: false,
                    value: value,
                    valueText: valueText,
                },
                ...this.state.requestParams.slice(paramIndex + 1),
            ],
        });
    };

    handleRequestSubmit = e => {
        const { requestParams, requestStatus } = this.state;

        if (requestStatus === REPORT_REQUEST_STATUS.Saving || requestStatus === REPORT_REQUEST_STATUS.Success) {
            return;
        }

        if (requestParams === null || requestParams.length <= 0) {
            this.setState({
                requestStatus: REPORT_REQUEST_STATUS.Error,
            });
            return;
        }

        if (requestParams.filter(p => !p.value).length > 0) {
            this.setState({
                requestStatus: REPORT_REQUEST_STATUS.ErrorAllRequiredFieldsAreNeeded,
            });
            return;
        }

        this.setState({
            requestStatus: REPORT_REQUEST_STATUS.Saving,
        });

        this.props
            .createReportRequest(
                this.props.reportCategoryDetails.reportId,
                requestParams.map(p => ({
                    reportParamId: p.paramId,
                    value: p.value,
                }))
            )
            .then(succes => {
                this.setState({
                    requestStatus: REPORT_REQUEST_STATUS.Success,
                });

                this.props.dispatch(push(PAGE_CUSTOMER.Reports));
            })
            .catch(error => {
                this.setState({
                    requestStatus: REPORT_REQUEST_STATUS.Error,
                });
            });
    };

    setInitialReportParamsState = reportRequest => {
        this.setState({
            requestParams: reportRequest
                ? reportRequest.params.map(param => ({
                      paramId: param.reportParamId,
                      value: param.reportParamType === 'string' ? '' : null,
                      valueText: '',
                      isExpanded: false,
                  }))
                : [],
        });
    };
}

RequestReportForm.propTypes = propTypes;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestReportForm);



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/Form/index.jsx